<template>
    <div class="task-card">
        <div class="task-card__inner">
            <div class="task-card__header">
                <a :href="url" class="task-card__cover">
                    <img :src="image.src" :alt="image.alt" :title="image.title">
                </a>
            </div>
            <div class="task-card__body">
                <div class="task-card__category">{{ category }}</div>
                <a :href="url" class="task-card__title">{{ title }}</a>
                <div class="task-card__text" v-if="layout==='line'">{{ text }}</div>
            </div>
            <div class="task-card__deadline" v-if="deadline">
                <a-badge>{{ deadline }}</a-badge>
            </div>
            <div class="task-card__footer">
                <div class="flex v-center between">
                    <div class="task-card__volunteers flex v-center">
                        <div class="task-card__volunteers-avatars flex v-center">
                            <div class="task-card__volunteers-avatar" v-for="(item, i) in volunteers" :key="i">
                                <img :src="item.avatar.src"  :alt="item.avatar.alt"  :title="item.avatar.title">
                            </div>
                        </div>
                        <div class="task-card__volunteers-responds">{{ responds }}</div>
                    </div>
                    <div class="task-card__rating flex v-center">
                        <svg class="icon" width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.9635 5.06994C13.8719 4.78645 13.6204 4.58511 13.3229 4.5583L9.28216 4.19139L7.68432 0.451504C7.56651 0.177419 7.29819 0 7.00007 0C6.70195 0 6.43364 0.177419 6.31582 0.452145L4.71798 4.19139L0.67656 4.5583C0.379616 4.58575 0.128816 4.78645 0.0366355 5.06994C-0.0555452 5.35342 0.0295858 5.66436 0.254216 5.86036L3.30857 8.53905L2.40791 12.5065C2.34201 12.7982 2.45523 13.0997 2.69727 13.2747C2.82737 13.3687 2.97958 13.4165 3.13307 13.4165C3.26542 13.4165 3.39669 13.3808 3.51451 13.3103L7.00007 11.2271L10.4844 13.3103C10.7393 13.4637 11.0607 13.4497 11.3022 13.2747C11.5444 13.0992 11.6575 12.7975 11.5916 12.5065L10.6909 8.53905L13.7453 5.8609C13.9699 5.66436 14.0557 5.35396 13.9635 5.06994Z"/>
                        </svg>
                        <span>{{ rating_min }}/{{ rating_max }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ABadge } from '../ui'

export default {
    name: 'TaskCard',
    functional: true,
    components: {
        ABadge,
    },
    inheritAttrs: false,
    props: {
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        image: {
            type: String,
            default: '',
        },
        category: {
            type: String,
            default: '',
        },
        deadline: {
            type: String,
            default: '',
        },
        responds: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        rating_min: {
            type: String,
            default: '',
        },
        rating_max: {
            type: String,
            default: '',
        },
        volunteers: {
            type: Array,
            default: [],
        },
        layout: {
            type: String,
            validator(val) {
                return ['line', 'grid'].includes(val)
            }
        }
    },
    setup: (props, ctx) => {

        return {

        }
    },
}
</script>

<style lang="scss">
    .task-card {
        &__header {
            height: 120px;
          img {
            max-height: 100%;
          }
        }
        &__inner {
            display: flex;
            flex-direction: column;
            background: #fff;
            height: 100%;
            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
            border-radius: var(--br-1);
            overflow: hidden;
            padding: 34px 24px 24px 30px;

            @include tablet {
                padding: 20px;
            }
        }
        &__body {
            margin-top: 7px;
        }
        &__text{
            font-weight: 400;
            font-size: 16px;
            line-height: 26px;
            @include rowDots(4)
        }
        &__title {
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            color: var(--c-gray-100);
            max-width: 100%;
            height: auto;
            margin-bottom: 15px;
            max-height: 72px;
            @include rowDots(3)
        }
        &__category {
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 7px;
            color: var(--c-secondary-200);
        }
        &__deadline {
            margin-top: 23px;
            min-height: 28px;
            .a-badge {
                color: var(--c-gray-400);
            }
        }
        &__footer {
            margin-top: auto;
            padding-top: 32px;
        }
        &__volunteers {
            &-avatar {
                width: 24px;
                height: 24px;
                min-width: 24px;
                min-height: 24px;
                border: 2px solid #fff;
                border-radius: 50%;
                overflow: hidden;
                margin-left: -12px;

                &:first-child {
                    margin-left: 0;
                    z-index: 3;
                }
                &:nth-child(2) {
                    z-index: 2;
                }
                &:nth-child(3) {
                    z-index: 1;
                }

                img {
                    object-fit: cover;
                    width: 100%;
                    height: 100%;
                  border-radius: 50%;
                }
            }
            &-responds {
                margin-left: 5px;
                white-space: nowrap;
                font-size: 14px;
                line-height: 19px;
                color: var(--c-gray-400);
                font-weight: 700;
            }
        }
        &__rating {
            color: var(--c-gray-400);
            font-size: 14px;
            .icon {
                margin-right: 5px;
                fill: currentColor;
            }
        }
    }
</style>
